import { User } from "../../types"
import {
  CurrentUserActionTypes,
  UpdateAction,
} from './types';

export function updateCurrentUser(user: User): UpdateAction {
  return {
    type: CurrentUserActionTypes.UPDATE,
    payload: user,
  };
}
